import { isValid as isValidCpf } from "@fnando/cpf";
import { isValid as isValidCnpj } from "@fnando/cnpj";
import externalProtocolName from "@/utils/external-protocol-name";

const validationRules = {
  cpf: v => (v && isValidCpf(v)) || "Você precisar fornecer um CPF válido.",
  cnpj: v => (v && isValidCnpj(v)) || "CNPJ inválido",
  email: v => /.+@.+/.test(v) || "Endereçco de e-mail inválido.",
  number: v => v.length === 8 || `Número de ${externalProtocolName()} inválido`,
  passwordMinLength: v =>
    (v && v.length >= 8) || "Sua senha deve conter no mínimo 8 caracteres.",
  postalcode: v => v.length >= 8 || "CEP deve ter 8 dígitos",
  required: v => !!v || "Este campo não pode ficar em branco.",
  smsCode: v => v.length === 6 || "O código deve ter 6 dígitos",
  noSpaces: v =>
    v ? !v.includes(" ") || "Este campo não pode conter espaços." : false,
  // v only can have letters
  noSpecialAndNumbers: v =>
    /^[a-zA-Z_]+$/.test(v) || "Este campo só pode conter letras."
};

export default validationRules;



// WEBPACK FOOTER //
// ./src/mixins/validation-rules.js